// extracted by mini-css-extract-plugin
module.exports = {"root":"car_series_description__root__EQj2p text__text_align_center__2cSPH","container":"car_series_description__container__FrfSs","bold":"car_series_description__bold__UOszx"};